module.exports = __webpack_public_path__ + "static/media/result_rchic_ja.b37ae962.jpg";